/**
 * Skeleton
 * Pulse-animated placeholder that respects prefers-reduced-motion.
 * Use to approximate the final layout shape and prevent CLS.
 */

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={`bg-border/50 rounded-lg animate-pulse motion-reduce:animate-none ${className}`}
    />
  );
}

/**
 * Pre-built skeleton matching the TrackingDisplay page layout.
 */
export function TrackingPageSkeleton() {
  return (
    <div className="mx-auto max-w-5xl space-y-6">
      {/* Journey visualizer placeholder */}
      <Skeleton className="w-full aspect-video rounded-3xl" />

      {/* Info cards row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Skeleton className="h-24 rounded-2xl" />
        <Skeleton className="h-24 rounded-2xl" />
        <Skeleton className="h-24 rounded-2xl" />
      </div>

      {/* Captain's Log placeholder */}
      <div className="rounded-3xl border border-border overflow-hidden">
        <Skeleton className="h-20 rounded-none" />
        <div className="p-6 space-y-4">
          <Skeleton className="h-16" />
          <Skeleton className="h-16" />
          <Skeleton className="h-16" />
        </div>
      </div>
    </div>
  );
}

/**
 * Pre-built skeleton matching the lookup results page layout.
 */
export function LookupResultsSkeleton() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      {/* Order header card */}
      <Skeleton className="h-24 rounded-lg" />

      {/* Shipment heading */}
      <Skeleton className="h-6 w-48" />

      {/* Shipment cards */}
      <Skeleton className="h-56 rounded-lg" />
      <Skeleton className="h-56 rounded-lg" />
    </div>
  );
}
